import React from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import SpaPage from "../pages/spa/index";
import Recepcion from "../pages/spa/Recepcion";
import RecepcionConfirmacion from "../pages/spa/RecepcionConfirmacion";
import AuthPage from "../pages/spa/login";
import { useDeviceDetector } from "../utils/isTv";
import TicketsPage from "../pages/TicketsPage";
import MenuHoyPage from "../pages/MenuHoyPage";
import BirthdayPage from "../pages/BirthdayPage";

const SpaLayout = ({ panelControl, setPanelControl }) => {
  const isTV = useDeviceDetector();
  return (
    <Router>
      <Routes>
        {/* <Route
          path="/pedidos"
          element={
            <SpaPage
              panelControl={panelControl}
              setPanelControl={setPanelControl}
            />
          }
        ></Route> */}

        {/* Ruta especial para TV */}
        {isTV && <Route path="/tv" element={<TicketsPage />} />}
        {/* {isTV && <Route path="/menu-panel" element={<MenuHoyPage />} />} */}
        <Route path="/tv" element={<TicketsPage />} />
        <Route path="/menu-panel" element={<MenuHoyPage />} />
        <Route path="/birthday" element={<BirthdayPage />} />

        <Route
          path="/auth"
          element={
            localStorage.getItem("init") ? (
              <SpaPage
                panelControl={panelControl}
                setPanelControl={setPanelControl}
              />
            ) : (
              <AuthPage />
            )
          }
        ></Route>
        <Route path="/recepcion" element={<Recepcion />} />
        <Route path="/recepcion-auth" element={<RecepcionConfirmacion />} />
        <Route
          path="/"
          element={
            isTV ? (
              <Navigate to="/tv" replace />
            ) : (
              <Navigate to="/auth" replace />
            )
          }
        />
        <Route
          path="*"
          element={
            isTV ? (
              <Navigate to="/tv" replace />
            ) : (
              <Navigate to="/auth" replace />
            )
          }
        />
      </Routes>
    </Router>
  );
};

export default SpaLayout;
